import styled from 'styled-components'

import { ChatCommentStyled } from '../components/ChatComment/styles/ChatCommentStyled'

interface IChatConversationStyledProps {}

export const ChatConversationStyled = styled.div<IChatConversationStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  position: relative;

  height: ${(props) => props.theme.typography.pxToRem(350)};

  background-color: ${(props) => props.theme.colors.offwhite};

  overflow-x: hidden;
  overflow-y: auto;

  padding: 1em;

  ${ChatCommentStyled} .comment {
    max-width: ${(props) => props.theme.typography.pxToRem(330)};
    min-width: ${(props) => props.theme.typography.pxToRem(230)};
  }
`
